
import * as defaultImport from "string-format-obj";
export * from "string-format-obj";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
